/*
 * @Description:
 * @Author: 山淑兰
 * @Date: 2019-09-06 15:53:39
 * @LastEditTime : 2019-12-31 10:20:46
 * @LastEditors  : 山淑兰
 */
/**
 * Created by Cray on 2017/1/5.
 */
import axios from './axios'

import MeetingApi from './modules/meeting' // 用户接口
import CommonApi from './modules/common' // 用户接口

export default Object.assign(
  // Host,
  MeetingApi,
  CommonApi,
  {
    put({ url, headers = this.getHeaders(), params = {} }) {
      return axios({
        method: 'put',
        url,
        headers,
        data: params,
        timeout: 20000
      })
    },
    putParam({ url, headers = this.getHeaders(), params = {} }) {
      return axios({ method: 'put', url, headers, params, timeout: 20000 })
    },
    post({ url, headers = this.getHeaders(), params = {} }) {
      return axios({
        method: 'post',
        url,
        headers,
        data: params,
        timeout: 20000
      })
    },
    get({ url, headers = this.getHeaders(), params = {} }) {
      return axios({ method: 'get', url, headers, params, timeout: 20000 })
    },
    delete({ url, headers = this.getHeaders(), params = {} }) {
      return axios({ method: 'delete', url, headers, params, timeout: 20000 })
    },
    getHeaders() {
      // const { _DJ_TOKEN } = Utils.getCookie()
      const headers = {
        'Content-Type': 'application/json;charset=UTF-8'
      }
      // if (_DJ_TOKEN) {
      //   headers.token = _DJ_TOKEN
      // }
      return headers
    }
  }
)
